import React from 'react';
import Plot from 'react-plotly.js';

const TimePlot = ({ finalTP, prevalence, sensitivity, specificity }) => {
  // Pre-defined values from your R code
  const actualTrials = [
    { Screened: 6757, Included: 1643, Duration: 2.8 },
    { Screened: 6173, Included: 1653, Duration: 2.9 },
    { Screened: 3736, Included: 813, Duration: 1.8 },
    { Screened: 3664, Included: 806, Duration: 1.5 }
];

  // Calculating rates and efficiencies from actual trials
  const actualRates = actualTrials.map(trial => trial.Included / trial.Duration);
  const actualEfficiencies = actualTrials.map(trial => trial.Included / trial.Screened);
  const benchmarkEfficiency = actualEfficiencies.reduce((a, b) => a + b, 0) / actualEfficiencies.length;
  const meanRate = actualRates.reduce((a, b) => a + b, 0) / actualRates.length;
  
  const screenedWithPreScreening = Math.ceil(finalTP / (sensitivity * prevalence))

  // Hypothetical trials data based on inputs
  const hypotheticalTrials = [
    { Trial: 'Only screening', Screened: finalTP / prevalence, Included: finalTP },
    { Trial: 'Pre-screening', Screened: screenedWithPreScreening, Included: finalTP },
  ];

  hypotheticalTrials.forEach(trial => {
    trial.Efficiency = trial.Included / trial.Screened;
    trial.EfficiencyFactor = trial.Efficiency / benchmarkEfficiency;
    trial.TimeToInclude = trial.Included / meanRate;
    trial.AdjustedTimeToInclude = trial.TimeToInclude / trial.EfficiencyFactor;
  });

  // Generating plot data
  const plotData = hypotheticalTrials.map((trial, index) => ({
    type: 'scatter',
    mode: 'lines',
    name: trial.Trial,
    x: Array.from({ length: 21 }, (_, i) => i * (trial.AdjustedTimeToInclude / 20)),
    y: Array.from({ length: 21 }, (_, i) => Math.min(meanRate * trial.EfficiencyFactor * i * (trial.AdjustedTimeToInclude / 20), trial.Included)),
    line: {
        shape: 'spline',
        color: index === 0 ? '#C9AB77' : '#B6BEC1'
    }
  }));

  return (
    <Plot
      data={plotData}
      layout={{
        xaxis: { title: 'Time (Years)', showline: true, linewidth: 1, linecolor:'black' },
        yaxis: { title: 'Cumulative Patients Included', type: 'log', dtick: 1 },
        margin: { l: 50, r: 0, b: 0, t: 0, pad: 0 },
        legend: { orientation: 'h', x: 0.5, y: -0.2, xanchor: 'center' },
        autosize: true,
        height: 400
      }}
      useResizeHandler={true}
      style={{ width: "100%" }}
    />
  );
};

export default TimePlot;
